import {AnalyticOperation, Currency, Partner, Project, Service, ServiceOrder} from '@app/shared';

interface BaseOrder {
  // --- Identificación y estado ---
  id: number;
  version: number;
  state: string;
  reference: string;           // Referencia única (ej: "FAC-2023-001")

  // --- Valores financieros ---
  total: number;
  reimbursableExpenses?: number;
  iva?: number;
  retention?: number;
  totalPay?: number;

  // --- Moneda ---
  currencyId: number;
  currency?: Currency; // Relación con Currency

  // --- Usuarios y fechas ---
  transmitterId: number;
  transmitter?: Partner; // Relación con Partner
  transmitterDate?: string;

  revisionId?: number;
  revision?: Partner | null;
  revisionDate?: string | null;

  shipperId?: number;
  shipper?: Partner | null;
  shipperDate?: string | null;

  approverId?: number;
  approver?: Partner | null;
  approverDate?: string | null;

  rejectorId?: number;
  rejector?: Partner | null;
  rejectedDate?: string | null;
  rejectedReason?: string | null;

  // --- Facturación ---
  invoiceId?: number;
  bill?: string | null;
  invoiceShippingDate?: string | null;
  invoiceDueDate: string;

  // --- Operaciones analíticas ---
  analyticOperations?: AnalyticOperation[];

  // --- Referencia al documento ---
  pdfPartners?: {
    id?: number,
    partnerId?: number,
    url?: string,
    currencyId?: number,
    functionStatus?: string,
  }[];

  functionStatus?: string; // URL para saber estados de los PDFs

  clientInvoiceId?: number;    // ID de factura del cliente
  clientInvoiceIdDate?: string | Date | null;    // Fecha en q se introduce el ID de factura del cliente
  clientInvoiceAmount?: number | null;
  clientInvoiceDate?: string | Date | null;
  supplierInvoiceId?: number;  // ID de factura del proveedor
  supplierInvoiceIdDate?: string | Date | null;  // Fecha en q se introduce el ID de factura del proveedor
}


export interface InvoiceOrder extends BaseOrder {
  // --- Campos específicos de facturación ---
  serviceValue: number;        // Valor base del servicio
  isActive: boolean;           // Estado de actividad en sistema
  invoiceOrderedId?: number;   // ID de orden vinculada (si aplica)


          // --- Propiedades adicionales para la vista de administración ---
          project?: Project;           // Proyecto asociado
          service?: Service;           // Servicio asociado
          serviceOrder?: ServiceOrder; // ServiceOrder asociado
          purchaseOrder?: PurchaseOrder | null; // InvoiceOrder asociado
}

export interface PurchaseOrder extends BaseOrder {
  // --- Campos específicos de compras ---
  value: number;               // Valor total de la compra
  flow?: string;               // Flujo de aprobación (ej: "direct", "multi-level")
  technicalSpecifications?: string; // Especificaciones técnicas
  destinationContactId?: number;    // ID contacto destino
  origin?: string;             // Origen de los bienes/servicios
  destination?: string;        // Destino de entrega
  supplierInvoiceAmount?: number | null;
  
  // --- Propiedades adicionales para la vista de administración ---
  project?: Project;           // Proyecto asociado
  service?: Service;           // Servicio asociado
  serviceOrder?: ServiceOrder; // ServiceOrder asociado
  invoiceOrder?: InvoiceOrder | null; // InvoiceOrder asociado
}

export interface InvoiceOrderCreate {
  analyticOperationIds: AnalyticOperation[],
  reference: string,
  currencyId: number,
  transmitterId: number,
}
